import axios from 'axios';

export function getList() {
    return axios.get('/api/services/app/City/GetList');
}